import { render, staticRenderFns } from "./perfil-da-loja.html?vue&type=template&id=3a97cd8c&scoped=true&"
import script from "./perfil-da-loja.vue?vue&type=script&lang=js&"
export * from "./perfil-da-loja.vue?vue&type=script&lang=js&"
import style0 from "./perfil-da-loja.less?vue&type=style&index=0&id=3a97cd8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a97cd8c",
  null
  
)

export default component.exports